/**
 *   Generated file. Do not edit
 */

export const ResourceMetaData = {
  '/lora/ids': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/Bytes',
      },
    },
  },

  '/lora/config': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/LoraConfig',
      },
    },
  },
};
